module.exports = __webpack_public_path__ + "img/logo_ro.e5a713ff.png";